/* ============================================================
   FLOWZA — Shopify AJAX cart drawer
   Slide-in sidebar, real-time add / change / remove, live count,
   free-shipping progress. Uses the Shopify Cart API (/cart/*.js).
   ============================================================ */
(function () {
  "use strict";

  // Cart endpoints under the locale root ("/ar/cart.js") answer with
  // translated titles and variant names; plain "/cart.js" is always English.
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var drawer = document.getElementById("fz-drawer");
  if (!drawer) return;

  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }
  function trn(k, n, one, other, o) {
    var f = fzT[k];
    return fillIn(f && window.fzPlural ? window.fzPlural(f, n) : fillIn(n === 1 ? one : other, { count: n }), o);
  }
  var rtl = document.documentElement.dir === "rtl";

  var scrim   = document.querySelector(".fz-scrim");
  var itemsEl = drawer.querySelector(".fz-items");
  var subEl   = document.getElementById("fz-sub-amt");
  var coTotal = document.getElementById("fz-co-total");
  var saveRow = document.getElementById("fz-save-row");
  var saveAmt = document.getElementById("fz-save-amt");
  var rewardTxt  = document.getElementById("fz-reward-txt");
  var rewardBar  = document.getElementById("fz-cart-reward");
  var rewardFill = document.getElementById("fz-reward-fill");
  var rewardTicks = document.getElementById("fz-reward-ticks");
  var shipNote = document.getElementById("fz-ship-note");
  // Held once: render() moves this node into the items list, and the next
  // render rewrites that list's innerHTML -- which drops the node from the
  // DOM but not from this reference, so it can be put straight back.
  var pairsRow = drawer.querySelector(".fz-pairs");

  var FREE = parseInt(drawer.getAttribute("data-free-ship") || "0", 10);
  var fmt  = (drawer.getAttribute("data-money") || "{{amount}}").replace(/<[^>]*>/g, "").trim();
  // Bundle-discount ladder: [{qty, off(cents)}], ascending. Top tier = ceiling.
  // Product type the ladder discount is scoped to, so the bar can tell a
  // sock from a jumpsuit. Matches the Flowza Premium Collection the four
  // Bundle N Products discounts are attached to.
  var LADDER_TYPE = (drawer.getAttribute("data-ladder-type") || "Grip Socks").toLowerCase();
  // Preferred scope: the actual product IDs in the Flowza Premium Collection,
  // emitted by fz-ladder-ids. Product type is only a fallback.
  var LADDER_IDS = (drawer.getAttribute("data-ladder-ids") || "")
    .split(",").map(function (s) { return s.trim(); }).filter(Boolean);
  function inLadder(line) {
    if (LADDER_IDS.length) return LADDER_IDS.indexOf(String(line.product_id)) !== -1;
    return (line.product_type || "").toLowerCase() === LADDER_TYPE;
  }
  var LADDER = (drawer.getAttribute("data-ladder") || "2:8,3:28,4:40,5:56")
    .split(",").map(function (s) { var p = s.split(":"); return { qty: parseInt(p[0], 10), off: Math.round(parseFloat(p[1]) * 100) }; })
    .filter(function (t) { return t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  var TOP = LADDER.length ? LADDER[LADDER.length - 1] : { qty: 5, off: 5600 };
  var lastTotalCents = 0; // updated on each render; used for TikTok InitiateCheckout value

  function money(cents) {
    // Two decimals, matching Liquid's `| money` (the "save up to" lines strip
    // a trailing .00 themselves where they want a round figure).
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_with_comma_separator}}", amount)
      .replace("{{amount_no_decimals}}", Math.round(cents / 100))
      .replace("{{amount_no_decimals_with_comma_separator}}", Math.round(cents / 100));
  }
  // "AED 81", or "AED 81.50" when a discount leaves cents. This is prose --
  // the delivery copy everywhere else says "AED 150" -- not a price tag, so
  // it does not wear the "Dhs. 81.00" money format the line items do.
  function aed(cents) {
    return "AED " + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, "");
  }

  function setCount(c) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = c;
      el.classList.toggle("on", c > 0);
    });
  }

  function pulse() {
    document.querySelectorAll("[data-cart-btn]").forEach(function (b) {
      b.classList.remove("pulse"); void b.offsetWidth; b.classList.add("pulse");
    });
  }

  function open()  {
    var wasOpen = document.body.classList.contains("fz-open");
    document.body.classList.add("fz-open");
    refresh();
    if (!wasOpen && window.posthog && posthog.capture) {
      try { if (!posthog.has_opted_out_capturing()) posthog.capture("cart_opened"); } catch (e) {}
    }
  }
  function close() { document.body.classList.remove("fz-open"); }

  function lineMeta(item) {
    if (item.variant_title && item.variant_title !== "Default Title") return item.variant_title;
    // A single-variant product still has one option, called Title, whose value
    // is the literal string "Default Title" -- so the drawer printed
    // "Default Title" under every sock and every bundle. Only real options.
    if (item.options_with_values && item.options_with_values.length) {
      var vals = item.options_with_values
        .map(function (o) { return o.value; })
        .filter(function (v) { return v && v !== "Default Title"; });
      if (vals.length) return vals.join(" · ");
    }
    var type = item.product_type || "";
    var key = type.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
    return (window.fzT && fzT.types && fzT.types[key]) || type;
  }

  // Read the saving off the line itself rather than a table of handles. The
  // table was hand-typed and had gone stale -- it claimed Dhs. 28 and 16% off
  // the Studio Trio, which is 155 against 177: Dhs. 22 and 12%. This is
  // whatever Shopify actually took off, so it covers the bundles, the
  // compare-at reduction and anything added later, and cannot drift again.
  function lineSave(l) {
    var off = l.total_discount || ((l.original_line_price || 0) - (l.final_line_price || 0));
    if (!off || off <= 0 || !l.original_line_price) return null;
    return tr("you_save", "You save [amount] ([percent]% off)", { amount: money(off), percent: Math.round((off * 100) / l.original_line_price) });
  }

  // Quantity the shopper has asked for, per line key, while it is still on its
  // way to Shopify; and which lines have a request in flight. See setQty().
  var want = {};
  var busy = {};

  function render(cart) {
    setCount(cart.item_count);
    // The checkout form is outside the items list, so it survives the empty
    // state unless it is disabled here: an empty bag otherwise offers
    // "Checkout - Dhs. 0.00", which posts and lands straight back on /cart.
    var coBtn = drawer.querySelector('[name="checkout"]');
    if (coBtn) {
      coBtn.disabled = !cart.item_count;
      coBtn.style.opacity = cart.item_count ? "" : ".45";
      coBtn.style.pointerEvents = cart.item_count ? "" : "none";
    }
    if (!cart.items.length) {
      itemsEl.innerHTML =
        '<div class="fz-empty"><div class="fz-empty-mark">◯</div><p class="h3">' + tr("bag_empty_title", "Your bag is quiet.") + '</p><p class="muted">' + tr("bag_empty_body", "Grip socks, jumpsuits and sets are a tap away.") + '</p></div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (l) {
        var img = l.image
          ? '<img class="fz-thumb-img" src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="" loading="lazy">'
          : '<span class="fz-thumb-fb"></span>';
        var saveTxt = lineSave(l);
        var save = saveTxt ? '<div class="fz-item-save">' + saveTxt + '</div>' : "";
        return '<div class="fz-item" data-key="' + l.key + '">' +
          '<a class="fz-thumb" href="' + l.url + '">' + img + '</a>' +
          '<div class="fz-item-body">' +
            '<div class="fz-item-top">' +
              '<div><a class="fz-item-name" href="' + l.url + '">' + l.product_title + '</a>' +
              '<div class="muted fz-item-meta">' + lineMeta(l) + '</div>' + save + '</div>' +
              '<button class="fz-rm" data-act="remove" data-key="' + l.key + '" aria-label="' + tr("remove", "Remove") + '">&times;</button>' +
            '</div>' +
            '<div class="fz-item-bot">' +
              '<div class="fz-qty">' +
                '<button data-act="dec" data-key="' + l.key + '" aria-label="' + tr("decrease", "Decrease") + '">−</button>' +
                '<span>' + (l.key in want ? want[l.key] : l.quantity) + '</span>' +
                '<button data-act="inc" data-key="' + l.key + '" aria-label="' + tr("increase", "Increase") + '">+</button>' +
              '</div>' +
              '<strong>' + money(l.final_line_price) + '</strong>' +
            '</div>' +
          '</div></div>';
      }).join("");
    }
    // Prices: subtotal (before discount), savings (real applied discount), total.
    var subtotal = cart.original_total_price != null ? cart.original_total_price : cart.items_subtotal_price;
    var disc = cart.total_discount || 0;
    if (subEl) subEl.textContent = money(subtotal);
    if (coTotal) coTotal.textContent = money(cart.total_price);
    lastTotalCents = cart.total_price;
    if (saveRow) { if (disc > 0) { saveRow.hidden = false; if (saveAmt) saveAmt.textContent = "− " + money(disc); } else { saveRow.hidden = true; } }

    // Bundle reward bar — progress toward the next quantity tier.
    // Counts only what the ladder discount actually applies to. It counted
    // every line, so nineteen jumpsuits read as nineteen pairs and the bar
    // announced "Best bundle saving unlocked" over a discount those items
    // cannot earn: the four Bundle N Products discounts are scoped to the
    // Flowza Premium Collection, which is seven grip socks and no apparel.
    var pairs = cart.items.reduce(function (n, l) {
      return inLadder(l) ? n + l.quantity : n;
    }, 0);
    // Nothing in the bag can earn it: say nothing rather than dangle a sock
    // offer over a jumpsuit.
    if (rewardBar) rewardBar.hidden = cart.items.length > 0 && pairs === 0;
    var next = null;
    for (var i = 0; i < LADDER.length; i++) { if (pairs < LADDER[i].qty) { next = LADDER[i]; break; } }
    if (rewardFill) rewardFill.style.width = Math.min(100, (pairs / TOP.qty) * 100) + "%";
    if (rewardTicks && !rewardTicks.childElementCount) {
      LADDER.forEach(function (t) {
        var tick = document.createElement("span");
        tick.className = "fz-reward-tick";
        // Mirrored in RTL; the tick centres itself with translateX(-50%) either way.
        var at = Math.min(100, (t.qty / TOP.qty) * 100);
        tick.style.left = (rtl ? 100 - at : at) + "%";
        tick.setAttribute("data-label", money(t.off).replace(/.00$/, ""));
        rewardTicks.appendChild(tick);
      });
    }
    if (rewardTicks) Array.prototype.forEach.call(rewardTicks.children, function (tk, idx) {
      tk.classList.toggle("reached", pairs >= LADDER[idx].qty);
    });
    // Forward-looking only. It used to restate the saving the footer prints
    // two lines below as "Discount applied − Dhs. X", so the same number
    // appeared twice in one panel.
    if (rewardTxt) {
      if (pairs === 0) {
        rewardTxt.innerHTML = tr("ladder_start_html", "Add 2+ pairs of grip socks and save up to <strong>[amount]</strong>.", { amount: money(TOP.off).replace(/.00$/, "") });
      } else if (next) {
        rewardTxt.innerHTML = tr("ladder_more_html", "Add <strong>[more]</strong> to save up to <strong>[amount]</strong>.", { more: trn("more", next.qty - pairs, "[count] more", "[count] more"), amount: money(next.off).replace(/.00$/, "") });
      } else {
        rewardTxt.innerHTML = tr("ladder_done", "Best bundle saving unlocked.");
      }
    }

    // "Add another pair", under the lines. The ladder line above asks for one
    // more pair and used to offer no way to add it; shoppers closed the bag
    // to go hunting and three of five never came back. Moved into the items
    // list after each render (render rewrites that list), shown only while
    // the ladder is in play, and pairs already in the bag are left out.
    if (pairsRow) {
      var inBag = {};
      cart.items.forEach(function (l) { inBag[String(l.variant_id || l.id)] = true; });
      var offered = 0;
      Array.prototype.forEach.call(pairsRow.querySelectorAll("[data-variant]"), function (el) {
        var hide = !!inBag[el.getAttribute("data-variant")];
        el.hidden = hide;
        if (!hide) offered++;
      });
      var wanted = !!(cart.item_count && pairs > 0 && pairs < TOP.qty && offered > 0);
      // exp-cart-pairs-row, asked only when the row would show, so exposure is
      // the shoppers who could have seen it. control = the bag without it.
      if (wanted && window.fzExperiment && window.fzExperiment("exp-cart-pairs-row") === "control") wanted = false;
      pairsRow.hidden = !wanted;
      if (cart.item_count) itemsEl.appendChild(pairsRow);
    }

    // Anything else on the page that mirrors bag state -- the bundle builder's
    // minimum gate and ladder -- listens for this instead of polling /cart.js.
    document.dispatchEvent(new CustomEvent("fz:cart:updated", { detail: cart }));

    // Free-delivery progress. Sits above the checkout button now, and shows how
    // far the bag has come rather than only how far is left -- the average
    // simulated cart was AED 85 against a AED 150 threshold, i.e. more than
    // half way and never told so.
    // cart.total_price, after automatic discounts: that is the figure the
    // shipping rate itself is evaluated against, so the bar and the checkout
    // can never disagree about whether delivery is free.
    // Every .fz-ship on the page: the drawer's, and the cart page's own
    // server-rendered copy, which this keeps live after a drawer add.
    if (shipNote && FREE > 0) {
      var left = FREE - cart.total_price;
      var done = left <= 0;
      var noteHtml = done
        ? tr("ship_done", "You’ve unlocked free next-day delivery ✓")
        : tr("ship_left_html", "Add <strong>[amount]</strong> more for free next-day delivery", { amount: aed(left) });
      // What adding ONE pair actually does to the total: its price, less
      // whatever the bundle ladder takes off for the new pair count. Two
      // pairs at 118 sit AED 40 short, not 32, because the ladder already
      // took 8; a third pair adds 59 and the ladder takes 20 more, landing
      // the bag on AED 149 -- one dirham short of 150, which is exactly the
      // 3 Sept abandonment. So the nudge only shows when the pair it offers
      // GENUINELY clears the threshold after the discount it triggers.
      function ladderOff(q) { var off = 0; for (var i = 0; i < LADDER.length; i++) { if (q >= LADDER[i].qty) off = LADDER[i].off; } return off; }
      Array.prototype.forEach.call(document.querySelectorAll(".fz-ship"), function (wrap) {
        var n = wrap.querySelector(".fz-ship-note");
        if (n) n.innerHTML = noteHtml;
        var fill = wrap.querySelector(".fz-ship-fill");
        if (fill) fill.style.width = Math.max(0, Math.min(100, (cart.total_price / FREE) * 100)) + "%";
        // Nothing to make progress towards on an empty bag.
        wrap.hidden = !cart.item_count;
        wrap.classList.toggle("is-done", done);
        var nudge = wrap.querySelector(".fz-ship-nudge");
        if (nudge) {
          var np = parseInt(nudge.getAttribute("data-price"), 10) || 0;
          var after = cart.total_price + np - (ladderOff(pairs + 1) - ladderOff(pairs));
          nudge.hidden = !(cart.item_count && !done && np > 0 && after >= FREE);
        }
      });
    }
  }

  function refresh() {
    fetch(cartRoot + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  // Each tap used to read the quantity from the DOM and post it at once. Taps
  // faster than the round trip all read the same stale number: four taps on
  // "+" from 1 posted 2,2,2,3 and left 3 in the bag -- caught in replays as
  // rage-clicks on "+". Now the number updates on tap, and only one request
  // per line is in flight; when it lands, it sends the latest ask if it moved.
  // Shopify re-keys a line on every quantity change, so that follow-up must go
  // out under the line's new key -- the old one is rejected with a 400.
  function setQty(key, qty) {
    want[key] = qty;
    var row = itemsEl.querySelector('.fz-item[data-key="' + CSS.escape(key) + '"]');
    var sp = row && row.querySelector(".fz-qty span");
    if (sp) sp.textContent = qty;
    if (!busy[key]) send(key);
  }

  function send(key) {
    var qty = want[key];
    // Lines keep their order across a quantity change, so the position is how
    // the re-keyed line is found in the cart that comes back.
    var idx = Array.prototype.map.call(itemsEl.querySelectorAll(".fz-item"), function (r) { return r.dataset.key; }).indexOf(key);
    busy[key] = true;
    fetch(cartRoot + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        busy[key] = false;
        // A 422 (asking for more than is in stock) returns {status, description}
        // and no cart, so render() threw and the drawer kept showing the old
        // quantity -- the click looked like it simply did nothing.
        if (data && data.status) {
          delete want[key];
          alert(data.description || tr("qty_unavailable_html", "That quantity isn't available."));
          refresh();
          return;
        }
        var next = want[key];
        delete want[key];
        var line = qty > 0 && data.items[idx];
        if (next !== qty && line) {
          want[line.key] = next;
          render(data); // re-keys the row; it still shows the latest ask
          send(line.key);
          return;
        }
        render(data);
      })
      .catch(function () {
        busy[key] = false;
        delete want[key];
        refresh();
      });
  }

  // Quantity / remove (delegated)
  itemsEl.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-act]");
    if (!btn) return;
    var key = btn.dataset.key;
    var row = itemsEl.querySelector('.fz-item[data-key="' + CSS.escape(key) + '"]');
    var cur = key in want ? want[key] : row ? parseInt(row.querySelector(".fz-qty span").textContent, 10) : 1;
    if (btn.dataset.act === "inc") setQty(key, cur + 1);
    else if (btn.dataset.act === "dec") setQty(key, Math.max(0, cur - 1));
    else if (btn.dataset.act === "remove") setQty(key, 0);
  });

  // AJAX add-to-cart — intercept any cart add form
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form.pcard-addform, #pdp-form');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var original;
    if (submitBtn) { original = submitBtn.textContent; submitBtn.disabled = true; submitBtn.textContent = tr("adding", "Adding…"); }

    // Open the drawer NOW, not when Shopify answers. add.js takes ~1.5s on a
    // phone, and the shopper spent all of it looking at an unchanged page with
    // a greyed-out button -- the single worst moment to feel broken, because it
    // is the one action that turns a browser into a buyer. The drawer appears
    // instantly in a pending state and fills in when the line comes back.
    open();
    drawer.classList.add("is-adding");
    function settle() { drawer.classList.remove("is-adding"); }

    fetch(cartRoot + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (line) {
        // A 422 (out of stock / limit reached) comes back as {status, description}.
        // Opening the drawer anyway looked like a successful add.
        if (line && line.status) {
          settle();
          close();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original; }
          alert(line.description || tr("add_failed", "Sorry, that item could not be added."));
          return;
        }
        settle();
        pulse(); refresh();
        // PostHog add_to_cart (no-op if the key is unset or consent withheld)
        if (window.posthog && posthog.capture && line && !line.status) {
          // Which surface, which path, what kind. A pair added from the socks
          // landing page must be told from one added inside the bag, and a
          // single pair from a bundle, or no test of "bundle vs single" -- or
          // of anything in the bag -- can be read.
          var via = form.closest(".fz-pairs") ? "drawer-pairs"
                  : form.closest(".fz-ship-nudge") ? "drawer-nudge"
                  // getAttribute, not form.id: a form with <input name="id"> exposes
                  // that INPUT as form.id, so the string compare never matched.
                  : form.getAttribute("id") === "pdp-form" ? "pdp"
                  : form.closest(".fzc") ? "card" : "form";
          var ptype = line.product_type || "";
          var sf = window.fzSurface || {};
          posthog.capture("add_to_cart", {
            product_id: line.product_id, variant_id: line.id,
            name: line.product_title || line.title, handle: line.handle || null,
            product_type: ptype,
            kind: ptype === "Bundle" ? "bundle" : ptype === "Grip Socks" ? "single" : "apparel",
            via: via, page_type: sf.page_type || null, collection: sf.collection || null, page_product: sf.product || null,
            quantity: line.quantity, currency: "AED",
            value: (line.final_line_price || line.price || 0) / 100
          });
        }
        // TikTok AddToCart (no-op if pixel disabled)
        if (window.ttq && line && !line.status) {
          ttq.track("AddToCart", {
            content_type: "product", content_id: line.id,
            content_name: line.product_title || line.title,
            quantity: line.quantity, currency: "AED",
            value: (line.final_line_price || line.price || 0) / 100
          });
        }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original; }
      })
      .catch(function () {
        // The optimistic drawer must not be left hanging on a failed add.
        settle();
        close();
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original; }
      });
  });

  // Open drawer from any cart button instead of navigating -- except on the
  // cart page itself. main-cart.liquid addresses its rows positionally
  // (?line={{ forloop.index }}), so removing a line in the drawer shifts every
  // row beneath it while the page still shows the old order: the next Remove
  // click then deletes the wrong product. On /cart the button navigates.
  var onCartPage = !!document.querySelector(".cart-page, #main-cart, [data-cart-page]") ||
                   /^\/cart(\/|$|\?)/.test(window.location.pathname);
  if (!onCartPage) {
    document.querySelectorAll("[data-cart-btn]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
  }

  // TikTok InitiateCheckout on the drawer checkout button (no-op if pixel disabled)
  drawer.addEventListener("click", function (e) {
    if (!e.target.closest('[name="checkout"]')) return;
    // checkout_started is fired by the PostHog Custom Pixel (Settings -> Customer
    // events) instead. The pixel sees every route into checkout, not just this
    // button, and firing it here as well double-counted the funnel's first step.
    if (!window.ttq) return;
    ttq.track("InitiateCheckout", { currency: "AED", value: lastTotalCents / 100 });
  });

  // Close
  if (scrim) scrim.addEventListener("click", close);
  drawer.querySelectorAll("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", close);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  // Initial state (count + items)
  refresh();

  window.FlowzaCart = { open: open, close: close, refresh: refresh };
})();
